module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elAppleQRcode_710187.477c6402.jpg";